import React, {Component} from 'react';
import AuthenticatedApp from './AuthenticatedApp';
import Page from './pageComponent/Page';
import "../scss/App.scss"
import './loadingComponent/loadingStyle.scss';
import { withKeycloak } from '@react-keycloak/web';
import LoginActions from '../actions/LoginActions';
import SessionCheckLoader from './loadingComponent/SessionCheckLoader';


class App extends Component {
    componentDidMount() {
        this.checkAuthentication()
       }

       checkAuthentication() {
        const { keycloak } = this.props;

        if (keycloak) {
            // Check if user is authenticated
            if (!keycloak.authenticated) {
                keycloak.login();
                return;
            } else {
                LoginActions.login()
            }
        }
    }

    render() {
        const { keycloak } = this.props;
        return (
                keycloak.authenticated ? <Page /> : <SessionCheckLoader />
        );
    }
}
export default withKeycloak(AuthenticatedApp(App));
